var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "#5698ba",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.998 65.0007C93.4979 32.9985 410.998 31.497 442.998 63.501C474.998 95.5049 469.527 400.708 442.998 434C417.498 466.001 94.6029 471.733 57.4981 434C27.9981 404.001 24.498 97.0028 58.998 65.0007Z",
    fill: "#f0fff1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M289.962 278.665C317.562 264.131 336.381 235.165 336.381 201.804C336.381 153.865 297.517 115 249.575 115C201.634 115 162.769 153.865 162.769 201.804C162.769 235.167 181.589 264.133 209.192 278.667C172.227 292.75 144.003 325.608 135.261 366.102C134.051 371.706 137.135 377.46 142.779 378.481C163.038 382.148 196.587 385.833 249.596 385.833C302.604 385.833 336.154 382.148 356.412 378.481C362.035 377.465 365.112 371.731 363.908 366.148C355.177 325.631 326.944 292.752 289.962 278.665Z",
    fill: "#231942"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.cafcdfd5a758c32cbb135fabea7f514e.svg";
export { ForwardRef as ReactComponent };